import { useMemo } from "react";

import { CustomCellRendererProps } from "@ag-grid-community/react";
import { BodySmall, Box } from "@parspec/pixel";

import { TableItem } from "./types";
import { AGG_FOOTER_ROW_ID, commonCellStyle } from "./constants";
import { useSortedCellData } from "./hooks";
import { getLotName } from "./utils";

const textSXStyle = { lineHeight: commonCellStyle.lineHeight };

export function ManufacturerCellRenderer(props: CustomCellRendererProps<TableItem, Array<string>>) {
    // Sort the array of manufacturers present in each cell on column sort order change
    const { sortedData: sortedManufacturers } = useSortedCellData(props, props.value);

    if (!sortedManufacturers) return null;

    return sortedManufacturers.map(name => (
        <BodySmall
            key={name}
            lines={1}
            whiteSpace="normal"
            sx={textSXStyle}
            fontWeight={props.node.data?.id === AGG_FOOTER_ROW_ID ? 600 : undefined}
        >
            {name}
        </BodySmall>
    ));
};

export function LotNameCellRenderer(props: CustomCellRendererProps<TableItem>) {
    const { data } = props;

    const lotNames = useMemo(() => data?.lots.map(getLotName), [data?.lots]);
    const { sortedData: sortedLotNames } = useSortedCellData(
        props,
        lotNames
    );

    const maxLines = data?.manufacturers.length || 1;

    return (
        <Box display="flex" alignItems="center" height="100%">
            <BodySmall
                lines={maxLines}
                whiteSpace="normal"
                sx={textSXStyle}
                fontWeight={props.node.data?.id === AGG_FOOTER_ROW_ID ? 600 : undefined}
            >
                {sortedLotNames?.length ? sortedLotNames.join(", ") : "-"}
            </BodySmall>
        </Box>
    );
}